import { render } from "./mat-switch.vue?vue&type=template&id=7516f5e6"
import script from "./mat-switch.vue?vue&type=script&lang=js"
export * from "./mat-switch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__